<template>
  <v-app id="inspire">
    <v-content class="login-frame">
      <v-container class="fill-height " fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12 ml-5 ">
              <ValidationObserver v-slot="{ invalid }">
                <v-card-text>
                  <div class="text-center mt-8">
                    <p style="font-family: 'Kaleko', sans-serif;">
                      Te enviaremos un e-mail con las instrucciones de cambio de
                      correo.
                    </p>
                  </div>
                  <v-form>
                    <!-- Email -->
                    <VTextFieldWithValidation
                      rules="required"
                      v-model="user.email"
                      label="E-mail"
                    />
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="#9ccc3c"
                    @click="submit"
                    :disabled="invalid"
                    style="text-transform:none;color:#fff;font-family: 'Kaleko', sans-serif;"
                  >
                    Enviar
                  </v-btn>
                </v-card-actions>
                <v-spacer />
              </ValidationObserver>
            </v-card>
          </v-col>
        </v-row>
        <v-snackbar v-model="snackbar">
          {{ snackbarText }}
          <v-btn
            style="text-transform:none;"
            color="#9ccc3c"
            text
            @click="snackbar = false"
          >
            Ok
          </v-btn>
        </v-snackbar>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    source: String,
  },
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      user: {
        email: "",
      },
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  methods: {
    ...mapActions("auth", { sendEmail4ResetEmail: "sendEmail4ResetEmail" }),
    submit() {
      this.user.email = this.user.email.toLowerCase();
      this.sendEmail4ResetEmail(this.user).then(() => {
        this.$store.state.auth.NewEmailRecuperation = true;
        this.$store.state.auth.NewEmailRecuperationMsg =
          "Hemos enviado un correo de confirmación a tu e-mail, ingresa ahí para modificar el correo...";
        this.$router
          .push({
            name: "login",
          })
          .catch(() => {});
      });
      /* .catch((err) => {
          this.snackbar = true;
          this.snackbarText = err.nonFieldErrors[0];
        }); */
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/fontface";
.login-frame {
  background-image: url("../../assets/img/backgrounds/fondoazul.png");
  background-position: center center;
  background-size: cover;
}
</style>
